import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useResendHotelMail(code: string) {
  return useMutation({
    mutationFn: async () =>
      apiMutation('POST', {
        path: ENDPOINTS.resendHotelMail,
        params: { bookingCode: code },
      }) as Promise<void>,
    onSuccess: () => {
      message.success('Hotel mail successfully resent');
    },
    onError: () => {
      message.error('Failed to resend hotel mail');
    },
  });
}
